<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">卷详情（编织）</h1>-->
    <!--</header>-->
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">卷详情（编织）</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="border-bottom: 1px dashed #CCCCCC;margin-top:15px;" >
        <!--第一行-->
        <div class="sampling-first-title">
          <h4>基础信息</h4>
        </div>
        <!--第二行内容-->
        <div class="sampling-first-content">
          <!--第2行-->
          <div style="display: flex;padding-top: 0px;padding-bottom: 3px;">
            <div class="flex-1" style="font-size: 13px; display: flex;">
              <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 50px;padding-left: 12px;">
                <span>物料:</span>
              </div>
              <div class="flex-3" style="white-space: nowrap;">
                <span>{{scxtwph}} {{scxtwpmc}}</span>
              </div>
            </div>
            <div class="flex-1" style="font-size: 13px;display: flex;padding-top: 0px;padding-bottom: 3px;">
              <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
                <span>已检数量:</span>
              </div>
              <div class="flex-3">
                <span>{{yjsl}}{{dw}}</span>
              </div>
            </div>
          </div>
          <!--第1行-->
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>外注订单:</span>
            </div>
            <div class="flex-9">
              <span>{{ddh}}</span>
            </div>
          </div>
          <!--第2行-->
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;">
           <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>订单数量:</span>
            </div>
            <div class="flex-9">
              <span>{{sl}}{{dw}}</span>
            </div>
          </div>
          <!--第3行-->
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↓ -->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;display: block;" class="hover-container">
            <div style="flex-grow: 1;display:flex">
              <div style="color: #333333;width:110px;"><!-- class="sampling-first-content-left" -->
                <span>订单未打卡数量:</span>
              </div>
              <div style="width:calc(100% - 110px);">
                <span>{{sysl}}{{dw}}</span>
                <span class="mui-icon mui-icon-info hover-trigger" style="font-size:20px;color:#1F6FB5" ></span>
              </div>
            </div>
            <div style="flex-grow: 1;font-size: 14px;padding-top: 0px;padding-bottom: 3px;margin-top:3px;" class="hover-content">
              <div class="hover-reveal" style="width:100%">订单未打卡数量 = 订单量 - TSD实际入库量（包含系统入库和无系统入库） - 生产未出库量 - 在途量</div>
            </div>
          </div>
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↑ -->
        </div>
      </div>
      <div class="sampling-first" style="border-bottom: 0px;">
        <div style="padding-top: 10px;position: relative">
          <!--第一行-->
          <div class="form-group">
            <div class="input-label">
              <label>织机机台：</label>
            </div>
            <div class="form-input">
            	<!-- 只读 -->
            	<input type="text" maxlength="10" v-model="machineno" disabled @blur.prevent="toUpperCase('machineno')" v-if="mode!='add'"/>
            	<!-- 只读 -->
            	<!-- 新增 -->
				      <div style="width: 85%;margin-bottom: 15px;" v-if="mode=='add'">
              		<multiselect v-model="minfo" :options="machineLst" :close-on-select="true" placeholder="请输入机台号"  label="machineno" track-by="machineno" @select="machineSel" :multiple="false" :showLabels = "false" :allowEmpty="false"></multiselect>
       			  </div>
       			<!-- 新增 -->
        	</div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>坯布品番：</label>
            </div>
            <div class="form-input">
              <select v-model="clothcodeinfo" v-show="mode=='add'" @change="clothchange">
                <option :value="item" v-for="(item,idx) in clothcodeLst" :key="idx">{{item.pbph}}</option>
              </select>
              <input type="text" v-model="clothcode" disabled v-show="mode!='add'"/>
            </div>
          </div>
          <div class="form-group" v-if="!isWB">
            <div class="input-label">
              <label>外注卷号：</label>
            </div>
            <div class="form-input">
              <input type="text" maxlength="20" v-model="wzrollno" :disabled="mode=='read' || (type=='edit' &&inspectflag=='0')" @blur.prevent="toUpperCase('wzrollno')"/>
            </div>
          </div>
           <div class="form-group" v-if="isWB">
            <div class="input-label">
              <label>外注卷号：</label>
            </div>
            <div class="form-input" v-if="mode=='read' || (type=='edit' &&inspectflag=='0')">
              <input type="text" maxlength="20" v-model="wzrollno" :disabled="mode=='read' || (type=='edit' &&inspectflag=='0')" @blur.prevent="toUpperCase('wzrollno')"/>
            </div>
            <div class="form-input" v-else>
              <div style="width: 85%;margin-bottom: 15px;" >
                <multiselect v-model="wzrollnoinfo" :options="wzrollLst" :close-on-select="true" placeholder="请输入外注卷号"  label="wzrollno" track-by="wzrollno" @select="wzrollnoSel" :multiple="false" :showLabels ="false" :allowEmpty="false" :taggable="true" @tag="handleCreateWzTag"></multiselect>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>匹数：</label>
            </div>
            <div class="form-input">
              <input type="text" maxlength="5" v-model="boltnum" :disabled="mode=='read' || (type=='edit' &&inspectflag=='0')" @blur.prevent="boltBlur()"/>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">净重：</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex:11;" maxlength="8" v-model="netweight" :disabled="mode=='read' || (type=='edit' &&inspectflag=='0')" />
              <div class="input-label" style="flex:3;text-align: center;">
                {{dw}}
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">落布日期：</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex: 11;" id="pickDateBtn" :data-options='dataoptions' v-model="fallingtime" :disabled="mode!='add'" @tap="showpicker" />
              <div class="input-label" style="flex:3;"></div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>挡车记录：</label>
            </div>
            <div class="form-input">
              <textarea rows="" cols="" v-model="dcremark" maxlength="200" :disabled="mode!='add'"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>验布记录：</label>
            </div>
            <div class="form-input">
              <textarea rows="" cols="" v-model="checkremark" maxlength="200" :disabled="!(type=='edit' &&inspectflag=='0')"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注：</label>
            </div>
            <div class="form-input">
              <textarea maxlength="10" v-model="remark" :disabled="mode!='add'"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注1：</label>
            </div>
            <div class="form-input">
              <textarea maxlength="250" v-model="remark1" :disabled="mode!='add'"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注2：</label>
            </div>
            <div class="form-input">
              <textarea maxlength="250" v-model="remark2" :disabled="mode!='add'"></textarea>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label"></label>
            <div class="form-input" style="padding-top: 0px;display: flex;display: inline-flex;">
              <div class="mui-input-row mui-checkbox mui-left">
                <label style="font-size: 14px;padding-left:20px;" for="changeyarn_flg">是否换纱</label>
                <input type="checkbox" v-model="changeyarn_flg" :disabled="mode!='add' || yarnuseflg || isfirstrollflg || isovernum || hasYarnHisflg" @change="hs" id="changeyarn_flg" style="left:0px;">
              </div>
              <div class="mui-input-row mui-checkbox mui-left">
                <label style="font-size: 14px;padding-left:30px;" for="clothhead_flg">布头标记</label>
                <input type="checkbox" v-model="clothhead_flg" :disabled="(mode!='add')||changeyarn_flg" id="clothhead_flg" style="left:10px;">
              </div>
            </div>
          </div>
          <div class="form-group" v-if="mode!='read'">
            <label class="input-label">标签设备：</label>
            <div class="form-input" style="display: flex;">
              <select v-model="device">
                <option :value="item" v-for="(item,idx) in deviceLst" :key="idx">{{item.f_dvname}}</option>
              </select>
              <span class="input-label" style="flex:3;">
              </span>
            </div>
          </div>
          <div class="form-group" style="width:100%;margin-top: 10px;margin-bottom: 10px;">
            <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;width: 80px;" v-if="mode!='read'" @tap="finish">完成</button>
            <button type="button" class="mui-btn mui-btn-default" style="margin: auto;width: 80px;" v-if="mode=='add'" @tap="conadd">继续添加</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
Vue.component('multiselect', Multiselect)
export default {
  name: "qualityDetailBZ",
  components: { Multiselect },
  data() {
    return {
      ddh: "",
      wph: "",
      scxtwph: "",
      scxtwpmc: "",
      yjsl: "",
      sl: "",
      dw: "",
      tsdrollno: "",
      machineno: "", // 织机机台
      clothcode: "", // 坯布品番
      clothcodeinfo: null,
      clothcodeLst: [],
      wzrollno: "", // 外注卷号
      old_wzrollno:"", // 编辑模式下 原始外注卷号
      boltnum: "", // 匹数
      old_boltnum:"", // 编辑模式下 原始匹数
      clothremakflg: "", // 坯布区分
      length: "", // 长度
      netweight: "", // 净重
      old_netweight:"", // 编辑模式下 原始净重
      fallingtime: "", // 落布时间
      remark: "", // 备注
      mode: "", // mode add read
      shipmentno: "",
      statusflg: "", // 状态 0：质检登录
      //dataoptions:'{"type":"date"}', // 年视图(年月日)
      dataoptions:'{"type":"datetime"}',// 完整日期视图(年月日时分)
      changeyarnflg: "0", // 0：未换纱 1：换纱
      changeyarn_flg: false,
      clothheadflg: "", // 0：非布头 1：布头
      clothhead_flg: false,
      dcremark: "", // 挡车记录
      checkremark: "", // 验布记录
      bdoresult: "",
      ksbh: "",
      deviceLst: [],
      device: null,
      fname: "",
      zdflg: false,
      breadth: "",// 幅宽
      gauge_length: "",// 规格幅长  
      fkdw: "",// 幅宽单位  
      fcdw: "",// 幅长单位
      bcc: "",// 编成长
      bccdw: "",// 编成长单位
      bzzl: "",// 标准重量  
      pbcf: "",// 坯布成分
      inspectflag: "",// 0：质检 1：不质检
      type: "",
      remark1: "",
      remark2: "",
      dbph: "",// 代表品号
      pbpm: "",// 坯布品名
      machineLst: [],
      minfo: null,
      yarnuseflg:false, // 是否启用换纱标识
      isfirstrollflg:false, // 是否是订单物料机台品番下的第一卷
      isovernum:false, // 是否超过订单设定的匹数的第一卷（订单、物料、机台、品番、同纱线）
      hasYarnHisflg:false, // 是否存在挂换纱履历
      erpcontract:0, // 是否订单来源于ERP 0：否 1：是
      wbzflag: 0, // 是否W编织订单 0:否 1：是
      iserpovernum:false, // 是否超过丸编纱线设定的最大匹数的第一卷（订单、物料、机台、品番、同纱线）
      supplementflg: "0", // 是否是卷补录 "0":非补录 "1":补录
      sysl:"", // 20250808 剩余打卡数量
      isWB: false, // 20251124
      wzrollnoinfo: {},
      wzrollLst:[]
    }
  },
  watch:{
    machineno:function(val){
      var value = isZMSZ(val);
      var str = (value).toUpperCase();
      str = str.replace(/I/g, '').replace(/O/g, '');
      this.machineno = str;
    },
    wzrollno:function(val){
      var tempval = val.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\u3040-\u309F\u30A0-\u30FF-\\\/\#\_\ ]/g,'');
      this.wzrollno = (tempval).toUpperCase();
    },
    boltnum:function(val){
      this.boltnum = isfloat(val);
    },
    netweight:function(val){
      this.netweight = isfloat(val);
    }
    // dcremark:function(val){
    //   this.dcremark = isText(val);
    // },
    // checkremark:function(val){
    //   this.checkremark = isText(val);
    // }
  },
  created() {},
  activated() {
    var v = this;
    const para = v.$route.params; //getJsonPara(v.$route);
    if (para && para.ddh) {
      v.ddh = para.ddh;
      v.wph = para.wph;
      v.ksbh = para.ksbh;
      v.type = para.type?para.type:"";
      // 是否是卷的补录
      if(para.supplementflg){
        v.supplementflg = para.supplementflg;
      }
      // 抽检
      if (para.shipmentno) {
        v.shipmentno = para.shipmentno;
        v.mode = "read";
      } else {
        v.shipmentno = "";
      }
      // 模式 新增、编辑
      if (para.tsdrollno) {
        v.tsdrollno = para.tsdrollno;
        v.mode = "read";
      } else {
        v.mode = "add";
        v.tsdrollno = "";
      }
      v.getJDetail();
    }
  },
  methods: {
  	machineSel(selectedOption,id){
  		var v = this;
  		v.machineno = selectedOption.machineno;
      // 20251125 追加 外注卷号的列表获取 ↓
      if(v.isWB){
        v.getWzrollnoList(false, function(){
          if(v.wzrollnoinfo.datafrom != 'input'){
            v.wzrollnoinfo = {};
            v.wzrollno = "";
          }
        });
      }
      // 20251125 追加 外注卷号的列表获取↑
     
      v.getMachineYarn();
    },
    getMachineYarn(){
      var v = this;
      if(v.mode!='add') return;
      // 根据选择的机台判断是否开启挂纱操作
      v.getMachineInfo(function(res){
        // 是否启用挂纱
        v.yarnuseflg = res.yarnuseflg;
        // 是否是订单物料该机台的第一卷或者超过订单匹数设定的第一卷
        v.checkFirstRoll(function(){
           // 判断是否超出了订单匹数设定的第一卷
           v.checkOrderBoltnumOver(function(){
             v.checkHasYarnChange(function(){
               v.yarnchoosecheck();
             });
           });
        })
      });
    },
    toFixed(num, s) {
      var times = Math.pow(10, s)
      var des = num * times + 0.5
      des = parseInt(des, 10) / times
      return des + ''
    },
    // 返回一个字符串，该字符串中的所有字母都被转化为大写字母
    toUpperCase(name){
      var v = this;
      if(name == 'machineno'){
        v.machineno = (v.machineno).toUpperCase();
      }else if(name == 'wzrollno'){
        v.wzrollno = (v.wzrollno).toUpperCase();
      }
    },
    setinfo(){
      var v = this;
      v.breadth = v.clothcodeinfo?v.clothcodeinfo.gcfk:"";// 幅宽
      v.gauge_length = v.clothcodeinfo?v.clothcodeinfo.gcfc:"";// 规格幅长  公称幅长
      v.fkdw = v.clothcodeinfo?v.clothcodeinfo.fkdw:"";// 幅宽单位  
      v.fcdw = v.clothcodeinfo?v.clothcodeinfo.fcdw:"";// 幅长单位
      v.bcc = v.clothcodeinfo?v.clothcodeinfo.bcc:"";// 编成长
      v.bccdw = v.clothcodeinfo?v.clothcodeinfo.bccdw:"";// 编成长单位
      v.bzzl = v.clothcodeinfo?v.clothcodeinfo.bzzl:"";// 标准重量  
      v.pbcf = v.clothcodeinfo?v.clothcodeinfo.pbcf:"";// 坯布成分  
      v.dbph = v.clothcodeinfo?v.clothcodeinfo.dbph:"";// 代表品号
      v.pbpm = v.clothcodeinfo?v.clothcodeinfo.pbpm:"";// 坯布品名
    },
    hs(){
      var v = this;
      if(v.changeyarn_flg){
        v.clothhead_flg = true;
      }
    },
    getpbph() {
      var v = this;
      for (var i = 0; i < v.clothcodeLst.length; i++) {
        if (v.clothcode == v.clothcodeLst[i].pbph) {
          v.clothcodeinfo = v.clothcodeLst[i];
          return;
        }
      }
    },
    getJDetail() {
      var v = this;
      v.nyy.doPost("/Quality/getJDetail", {
          ddh: v.ddh,
          wph: v.wph,
          tsdrollno: v.tsdrollno,
          supplementflg: v.supplementflg
        },
        function(result) {
          if (result.status) {
            var info = result.data.info;
            v.scxtwph = info.scxtwph;
            v.scxtwpmc = info.scxtwpmc;
            v.sl = info.sl;
            v.dw = info.dw;
            v.yjsl = info.yjsl;
            v.fname = info.fname;
            v.inspectflag = info.inspectflag;
            // 20211112 追加
            v.erpcontract = info.erpcontract;
            v.wbzflag = info.wbzflag;
            // 坯布品番
            v.clothcodeLst = result.data.pbphInfoList;
            //v.clothcodeLst = [{"pbph":"WZ3450","gcfc":50.0,"bzzl":6.23,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M","dbph":"WZ1230","pbpm":"国内丸编"},{"pbph":"WZ3450-1","gcfc":50.0,"bzzl":0.01,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M","dbph":"WZ1230","pbpm":"国内丸编"}];//result.data.pbphInfoList;

            v.deviceLst = result.data.deviceLst;
            v.device = (v.deviceLst && v.deviceLst.length>0)?v.deviceLst[0]:null;

            // 20251124 W编织标识 ↓
            v.isWB = result.data.isWB;
            // 20251124 W编织标识 ↑

            // 20250811 剩余未打卡数量 ↓
            // v.sysl = info.sysl;
            // 20250811 剩余未打卡数量 ↑

            if (v.mode == "add") {
              v.machineno = ""; // 织机机台
              v.clothcode = ""; // 坯布品番
              v.gauge_length = "";
              v.clothcodeinfo = (v.clothcodeLst && v.clothcodeLst.length>0)?v.clothcodeLst[0]:null;
              if(v.clothcodeinfo){
                v.clothcode = v.clothcodeinfo.pbph;
              }
              v.init();
              v.zdflg = false;
              v.machineLst = result.data.machineLst;
              //v.getMachineYarn();
            } else {
              v.machineno = info.machineno; // 织机机台
              v.clothcode = info.clothcode; // 坯布品番
              v.getpbph();
              v.wzrollno = info.wzrollno; // 外注卷号
              v.old_wzrollno = info.wzrollno; // 编辑模式下 原始外注卷号 20200221
              v.boltnum = info.boltnum; // 匹数
              v.old_boltnum = info.boltnum; // 编辑模式下 原始匹数
              v.clothremakflg = info.clothremakflg; // 坯布区分
              v.length = info.length; // 长度
              v.netweight = info.netweight; // 净重
              v.old_netweight = info.netweight; // 编辑模式下 原始净重 
              v.fallingtime = info.fallingtime; // 落布时间
              v.remark = info.remark; // 备注
              v.remark1 = info.remark1;// 备注1
              v.remark2 = info.remark2;// 备注2
              v.statusflg = info.statusflg;
              v.supplementflg = info.supplementflg; // 是否补录卷
              // 0:质检登录
              if (v.statusflg == '0') {
                v.mode = "edit";
              } else {
                v.mode = "read";
              }
              v.bdoresult = info.bdoresult;

              v.dcremark = info.dcremark; // 挡车记录
              v.checkremark = info.checkremark; // 验布记录
              v.changeyarnflg = info.changeyarnflg; // 0：未换纱 1：换纱
              v.changeyarn_flg = (info.changeyarnflg == '1' ? true : false);
              v.clothheadflg = info.clothheadflg; // 0：非布头 1：布头
              v.clothhead_flg = (info.clothheadflg == '1' ? true : false);

              v.zdflg = info.zdflg;// 是否已被指定
              if(v.zdflg){
                v.mode = "read";
              }
              // 20250811 剩余未打卡数量 ↓
              v.getContractSYAmount();
              // 20250811 剩余未打卡数量 ↑

              // 20251125 获取外注卷号列表 ↓
              v.wzrollLst = result.data.wzrollnoList || [];
              if(v.wzrollLst.length >0){
                let inputWzrollList = v.wzrollLst.filter(item => item.wzrollno == v.wzrollno);
                if(inputWzrollList.length >0){
                  v.wzrollnoinfo = inputWzrollList[0];
                }
                
              }
              // 20251125 获取外注卷号列表 ↑
            }
            v.setinfo();
          }
        }
      );
    },
    init() {
      var v = this;
      v.wzrollno = ""; // 外注卷号
      v.boltnum = ""; // 匹数
      v.clothremakflg = ""; // 坯布区分
      v.length = ""; // 长度
      v.netweight = ""; // 净重

      v.dcremark = ""; // 挡车记录
      v.checkremark = ""; // 验布记录
      v.changeyarnflg = "0"; // 0：未换纱 1：换纱
      v.changeyarn_flg = false;
      v.clothheadflg = "0"; // 0：非布头 1：布头
      v.clothhead_flg = false;

      var date = new Date(); //获取当前时间
      var now_date = v.getFormatDate(date) + " " + v.GetDefalutTime();
      v.fallingtime = now_date; // 落布时间

      v.remark = ""; // 备注
      v.remark1 = "";// 备注1
      v.remark2 = "";// 备注2
      v.statusflg = "";
      // 20250811 剩余未打卡数量 ↓
      v.getContractSYAmount();
      // 20250811 剩余未打卡数量 ↑
      // 20251124 外注卷号列表相关 ↓
      v.wzrollnoinfo = {};
      v.wzrollLst = [];
      // 20251124 外注卷号列表相关 ↑
    },
    showpicker() {
      var v = this;
      var dDate = new Date();
      var optionsJson = v.dataoptions;
      var options = JSON.parse(optionsJson);
      var picker = new mui.DtPicker(options);
      picker.show(function(rs) {
        console.log(rs)
        var timestr = rs.text;
        v.fallingtime = timestr.replace(/-/g, "/");
        picker.dispose();
        if(v.mode!='add') return;
        // 是否是订单物料该机台的第一卷或者超过订单匹数设定的第一卷
        v.checkFirstRoll(function(){
           // 判断是否超出了订单匹数设定的第一卷
           v.checkOrderBoltnumOver(function(){
             v.checkHasYarnChange(function(){
              v.yarnchoosecheck();
             });
           });
        })
      });
    },
     GetDefalutTime(){
      // 获取系统时间
      var systemDate = new Date();
      var sysTime = "";
      if (systemDate.getHours() < 10) {
          sysTime += "0" + systemDate.getHours();
      } else {
          sysTime += systemDate.getHours();
      }
      if (systemDate.getMinutes() < 10) {
          sysTime += ":0" + systemDate.getMinutes();
      } else {
          sysTime += ":" + systemDate.getMinutes();
      }
      return sysTime;
    },
    getFormatDate(date) {
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 完成
    finish() {
      var v = this;
      if (!v.check()) return;
      // 校验标签设备是否选择
      if (!v.device && (v.type != 'edit')) {
        mui.toast("请选择标签设备");
        return;
      }
      if(v.mode=='add'){
        // 校验同纱匹数
        v.checkSNum(function(){
            var postMap = v.setMap();
            postMap.labelprinttime = "";
            v.addJ(postMap, function() {
              v.printZJBQ();
              // v.printZJBQ(function(){
              //   // 当前外注供应商是W编织的情况下，勾选换纱，
              //   // 并落布完成（当前卷数据保存完成）后，画面跳转至 丸编换纱页面 
              //   if(v.yarnuseflg && v.erpcontract == 1 && v.wbzflag == 1 && v.changeyarn_flg){
              //     // 跳转到丸编换纱页面
              //     v.$router.push({ 
              //       name: 'weaveEnter', 
              //       params: { 
              //         machineno: v.machineno,
              //         wph: v.wph,
              //         ddh: v.ddh,
              //         optkind: "1" // 1:换纱处理
              //       }
              //     });
              //   }else{
              //     v.$router.go(-1);
              //   }
              // });
            });
        });
      }else{
          // 质检
          if(v.mode == "edit" || (v.inspectflag=='0' && v.type == "edit")){ // 20200221 追加 编辑模式可修改信息
            v.updateJ(function(){
              if(v.inspectflag=='0' && v.type == "edit"){ // 验布记录的模式下
                v.$router.go(-1);
              }else{
                // 判断修改前的值和修改后的是否有变化，如有，则重打标签
                //if((v.old_wzrollno != v.wzrollno) || (v.old_boltnum != v.boltnum) || (v.old_netweight != v.netweight)){
                  
                  v.printZJBQ();
                //}else{
                  //v.$router.go(-1);
                //}
              }
            },"");
          }else{
            v.printZJBQ();
          }
      }
    },
    checkSNum(callback){
      var v = this;
      // 换纱
      if(v.changeyarn_flg){
        if(callback) callback();
      }else{
        var postMap = {
          "ddh": v.ddh,
          "wph": v.wph,
          "machineno": v.machineno,
          "clothcode": v.clothcode,
          "boltnum": v.boltnum,
          "fallingtime": v.fallingtime
        };
        v.nyy.doPost("/Quality/checkSNum", postMap,
          function(result) {
            if (result.status) {
              if(callback) callback();
            }else{
              mui.toast(result.message);
            }
          }
        );
      }
    },
    // 打印质检标签
    printZJBQ(callback) {
      var v = this;
      var bcc = ((v.bcc == "")?"0":v.bcc);
      var length = (parseFloat(v.boltnum) * parseFloat(bcc)).toFixed(1);
      // 针织布的规格：幅宽+幅宽单位 * 幅长+幅长单位 (编成长 + 编成长单位)
      var postMap = {
        "tsdrollno": v.tsdrollno, // TSD卷号
        "clothcode": v.clothcode, // 坯布品番 (坯布质检 - 坯布品番 )
        "breadth": v.breadth, // ERP-幅宽（单位CM）
        "gauge_length": v.gauge_length, // ERP-公称幅长（单位M）
        "length": length, // 布  长
        "boltnum": v.boltnum, // 匹数
        "netweight": v.netweight, // 重    量
        "bdoresult": v.bdoresult, // 色 区 分 (悬念反处置结果 关联取样单号可以获取;若没有，固定值“无”)
        "fname": v.fname, // 织布工厂 (供应商-简称 表中数据对应简称2)
        "wzrollno": v.wzrollno, // 外注卷号
        "fallingtime": v.fallingtime, // 落布时间(yyyy年mm月dd日)
        "clothremakflg": "", // 坯布区分 机织的情况下使用
        "remark": v.remark, // 备    注
        "ddqf": "2", // 订单区分
        "dvno": v.device.dvno, // 终端编号
        "fkdw": v.fkdw,// 幅宽单位
        "fcdw": v.fcdw,// 幅长单位
        "bcc": v.bcc,// 幅成长
        "bccdw": v.bccdw// 幅成长单位
      };
      v.nyy.doPost("/Quality/printZJBQ", postMap,
        function(result) {
          if (result.status) {
            if(callback){
              callback();
            }else{
              v.$router.go(-1);
            }
          }
        }
      );
    },
    check() {
      var v = this;
      if (v.machineno == "") {
        mui.toast("请输入织机机台");
        return false;
      }
      if (v.clothcodeinfo == "") {
        mui.toast("请选择坯布品番");
        return false;
      }
      v.clothcode = v.clothcodeinfo.pbph;
      v.setinfo();
      if (v.wzrollno == "") {
        mui.toast("请输入外注卷号");
        return false;
      }
      //if((v.wzrollno).indexOf(v.machineno)<=-1){
      if(!v.wzrollno.startsWith(v.machineno)){
        mui.toast("请确认外注卷号和机台是否匹配");
        return false;
      }
      // 根据 录入的净重/标准重量 来校验匹数输入的范围是否正确
      if (v.boltnum == "") {
        mui.toast("请输入匹数");
        return false;
      }
      if(parseInt(v.boltnum)>999.99){
        mui.toast("请输入合法匹数");
        return false;
      }
      if (!v.isSZO(v.boltnum)) {
        mui.toast("请输入只含一位小数的匹数");
        return false;
      }
      // 根据 录入的净重/标准重量 来校验匹数输入的范围是否正确 todo
      if (v.netweight == "") {
        mui.toast("请输入净重");
        return false;
      }
      if (!is8SZ(v.netweight)) {
        mui.toast("请输入合法净重");
        return false;
      }
      if(parseInt(v.netweight)>999.99){
        mui.toast("请输入合法净重");
        return false;
      }
      if(v.boltnum<=0){
        mui.toast("请输入合法匹数");
        return false;
      }
      // 判断布匹数输入是否是0.5的倍数
      if(!v.checkZeroFive(v.boltnum)){
        mui.toast("请输入匹数正确的小数位的值");
        return false;
      }
      if(v.bzzl && (parseFloat(v.bzzl)>0)){
        /*// 匹数 称重重量/标准重量 ±1
        // 对数进行上舍入
        var ps_max = Math.ceil(parseFloat(v.netweight)/parseFloat(v.bzzl));
        // 对数进行下舍入
        var ps_min = Math.floor(parseFloat(v.netweight)/parseFloat(v.bzzl));
        if((parseFloat(v.boltnum) > ps_max) || (parseFloat(v.boltnum) < ps_min)){
          mui.toast("根据标准重量和输入的净重，匹数可输入区间为(" + ps_min + "," + ps_max + ")");
          return false;
        }*/
        // 匹数 称重重量/标准重量 上下浮动30% 20190524  吴给出的范围
        // 匹数规则 实际重量除以标准重量后直接+_0.3 2020/01/08 吴给出的范围 
        var ps_temp = (parseFloat(v.netweight)/parseFloat(v.bzzl)).toFixed(2);
        // var ps_max = v.toFixed((parseFloat(ps_temp) * (1 + 0.3)),1);
        // var ps_min = v.toFixed((parseFloat(ps_temp) * (1 - 0.3)),1);
        var ps_max = v.toFixed((parseFloat(ps_temp) + 0.3),1);
        var ps_min = v.toFixed((parseFloat(ps_temp) - 0.3),1);

        if((parseFloat(v.boltnum) > parseFloat(ps_max)) || (parseFloat(v.boltnum) < parseFloat(ps_min))){
          mui.toast("根据标准重量和输入的净重，匹数可输入区间为(" + ps_min + "," + ps_max + ")");
          return false;
        }
      }
      if (v.fallingtime == "") {
        mui.toast("请输入落布时间");
        return false;
      }
      if (v.dcremark == "") {
        mui.toast("请输入挡车记录");
        return false;
      }
      // 是否自主质检
      if (v.inspectflag == "0" && v.type=="edit") {
        if (v.checkremark == "") {
          mui.toast("请输入验布记录");
          return false;
        }
      }
      return true;
    },
    setMap() {
      var v = this;
      // 米数计算（编成长*匹数）
      var bcc = ((v.bcc == "")?"0":v.bcc);
      var length = (parseFloat(v.boltnum) * parseFloat(bcc)).toFixed(1);
      var postMap = {
        "ddh": v.ddh,
        "wph": v.wph,
        "wzrollno": (v.wzrollno).toUpperCase(), // 外注卷号
        "machineno": (v.machineno).toUpperCase(), // 织机机台
        "clothcode": v.clothcode, // 坯布品番
        "boltnum": v.boltnum, // 匹数
        "length": length, // 长度
        "netweight": v.netweight, // 净重
        "fallingtime": v.fallingtime, // 落布时间
        "remark": v.remark, // 备注
        "statusflg": "0",
        "ddqf": "2",
        "dcremark": v.dcremark, // 挡车记录
        "checkremark": v.checkremark, // 验布记录
        "changeyarnflg": (v.changeyarn_flg ? "1" : "0"), // 0：未换纱 1：换纱
        "clothheadflg": (v.clothhead_flg ? "1" : "0"), // 0：非布头 1：布头
        "ksbh": v.ksbh,
        "remark1": v.remark1,// 备注1
        "remark2": v.remark2,// 备注2
        "supplementflg": v.supplementflg // 是否补录
      };
      return postMap;
    },
    addJ(postMap, callback) {
      var v = this;
      v.Noclothhead_confirm(function(){
        // 新增字段
        postMap.breadth = v.breadth;// 幅宽
        postMap.gauge_length = v.gauge_length;// 规格幅长  
        postMap.fkdw = v.fkdw;// 幅宽单位  
        postMap.fcdw = v.fcdw;// 幅长单位
        postMap.bcc = v.bcc;// 编成长
        postMap.bccdw = v.bccdw;// 编成长单位
        postMap.bzzl = v.bzzl;// 标准重量
        postMap.pbcf = v.pbcf;// 坯布成分 
        postMap.dbph = v.dbph;// 代表品号
        postMap.pbpm = v.pbpm;// 坯布品名

        v.nyy.doPost("/Quality/addJ", postMap,
          function(result) {
            if (result.status) {
              v.tsdrollno = result.data.tsdrollno;

              // W编织提交确认flag
              var wb_confrimflag = result.data.wb_confirmflag;
              // W编织提交确认消息
              var wb_confirm_msg = result.data.wb_confirm_msg;
              // 若 wb_confrimflag = 0,则需弹出确认提示框
              if(wb_confrimflag == 1){
                mui.confirm(wb_confirm_msg, '提示', ['否', '是'], function(e) {
                  if (e.index == 1) {
                    postMap.tsdrollno = v.tsdrollno;
                    postMap.erpflag = "2";
                    v.addJ(postMap,callback);
                  }
                });
                return;
              }

              // 若是布头标记，则添加自动取样逻辑  (v.changeyarn_flg ? "1" : "0"), // 0：未换纱 1：换纱
              // 20220713 将自动取样的逻辑挪到后台完成。确保网络终端的情况
              //if(v.clothhead_flg){
              // if(postMap.clothheadflg == '1'){
              //   var sample_data = {
              //       "ddh": v.ddh,
              //       "wph": v.wph,
              //       "sampletime":v.fallingtime, // 落布时间
              //       "amount":"1.0",
              //       "tsdrollnolist":[{
              //         "machineno":v.machineno, // 织机机台
              //         "tsdrollno":v.tsdrollno // tsd卷号
              //       }],
              //       location:"4" // 取样位置
              //   }
              //   v.nyy.doPost("/Sample/insertSample",sample_data, 
              //     function(result){
              //       if(result.status){
              //          if (callback) callback();
              //       } else {
              //          mui.toast(result.message);
              //        }
              //     });
              // }else{
                 if (callback) callback();
              // }
            } else {
              var msg = result.message;
              var compare_msg = "机台存在未完成换纱操作，请先进行换纱操作后再进行落布！";
              var compare_msg2 = "系统没有检查到换纱履历，请先进行换纱操作后再进行落布！";
              // 若是W编织且是erp订单且机台需要挂纱时，存在机台没有完成挂纱操作或者没有检查到挂纱履历，则跳转到挂纱画面
              if(msg == compare_msg || msg == compare_msg2){
                if(v.yarnuseflg && v.erpcontract == 1 && v.wbzflag == 1 && v.changeyarn_flg){
                  // 
                  v.hz_confirm(msg,function(){
                      // 跳转到丸编换纱页面
                      v.$router.push({
                        name: 'weaveEnter', 
                        params: { 
                          machineno: v.machineno,
                          wph: v.wph,
                          ddh: v.ddh,
                          optkind: "1" // 1:换纱处理
                        }
                      });
                  });
                }else{
                   mui.toast(result.message);
                }
              }else{
                mui.toast(result.message);
              }
            }
          }
        );
      });

},
    // 继续添加
    conadd() {
      var v = this;
      if (!v.check()) return;
      // 校验同纱匹数
      v.checkSNum(function(){
        if (!v.device) {
            mui.toast("请选择标签设备");
            return;
        }
        var postMap = v.setMap();
        v.addJ(postMap, function() {
          v.printZJBQ(function(){
            v.init();
          });
        });
      });
    },
    Noclothhead_confirm(callback){
      var v = this;
      if(!v.clothhead_flg){
        mui.confirm('确定不进行布头标记？', '提示', ['否', '是'], function(e) {
          if (e.index == 1) {
            if(callback)callback();
          }
        });
      }else{
        if(callback)callback();
      }
    },
    hz_confirm(msg,callback){
      var v = this;
      mui.confirm(msg, '提示', ['暂不处理', '去换纱'], function(e) {
        if (e.index == 1) {
          if(callback)callback();
        }
      });
    },
    updateJ(callback,erpflag){
      var v = this;
      // 米数计算（编成长*匹数）
      var bcc = ((v.bcc == "")?"0":v.bcc);
      var length = (parseFloat(v.boltnum) * parseFloat(bcc)).toFixed(1);
      // 可修改验布记录
      var postMap = {
        "ddh": v.ddh,
        "wph": v.wph,
        "tsdrollno": v.tsdrollno,
        "checkremark": v.checkremark,
        "wzrollno": (v.wzrollno).toUpperCase(), // 外注卷号可编辑 2020/1/7 课题95
        "boltnum": v.boltnum, // 匹数 可编辑 2020/1/7 课题95
        "netweight": v.netweight, // 净重 可编辑 2020/1/7 课题95
        "length" : length, // 匹数变更时，长度对应变更 2020/4/24 课题95
        "machineno": (v.machineno).toUpperCase(), // 织机机台
        "clothcode":v.clothcode, // 坯布品番
        "fallingtime": v.fallingtime, // 落布时间
        "remark": v.remark, // 备注
        "dcremark": v.dcremark // 挡车记录
      };
      if(erpflag){
        postMap.erpflag = erpflag;
      }
      v.nyy.doPost("/Quality/updateJ", postMap,
        function(result) {
          if (result.status) {
            // W编织提交确认flag
            var wb_confrimflag = result.data.wb_confirmflag;
            // W编织提交确认消息
            var wb_confirm_msg = result.data.wb_confirm_msg;
            // 若 wb_confrimflag = 0,则需弹出确认提示框
            if(wb_confrimflag == 1){
              mui.confirm(wb_confirm_msg, '提示', ['否', '是'], function(e) {
                if (e.index == 1) {
                  v.updateJ(callback,"2");
                }
              });
              return;
            }
            if (callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    // 正实数，整数位最多3位，最多1位小数
    isSZO(str) {
      var reg = /^\d{1,3}$|^\d{1,3}[.]\d{1,1}$/;
      if (!reg.test(str)) {
          return false;
      }
      return true;
    },
    // 判断是否是0.5的整倍数
    checkZeroFive(str){
      var num = parseFloat(str) * 10;
      var num_qy = num % 5;
      if(num % 5 == 0){
        return true;
      }
      return false;
    },
    getMachineInfo(callback){
      var v = this;
      // 获取机台信息(是否启用挂纱)
      var postMap = {
        "machineno": v.machineno,
        "ddh":v.ddh,
        "wph":v.wph
      };
      v.nyy.doPost("/Quality/getMachineInfo", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback(result.data);
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    doCheckFirstRollApi(callback){ // 检查是否是订单物料机台下一个品番的第一卷
      var v = this;
      // 检查是否是订单物料机台下一个品番的第一卷
      var postMap = {
        "machineno": v.machineno,
        "clothcode": v.clothcode,
        "ddh":v.ddh,
        "wph":v.wph,
        "fallingtime":v.fallingtime
      };
      v.nyy.doPost("/Quality/checkFirstRoll", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback(result.data);
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    clothchange(){
      var v = this;
      v.clothcode = v.clothcodeinfo.pbph;
      if(v.isWB && v.mode == 'add'){
        // 2025.11.25 根据机台号和坯布品号获取外注卷号 ↓
        v.getWzrollnoList(true, function(){
          if(v.wzrollnoinfo.datafrom != 'input'){
            v.wzrollnoinfo = {};
          }
        });
        // 2025.11.25 根据机台号和坯布品号获取外注卷号 ↑
      }
      if(v.mode!='add') return;
      // 判断是否是订单物料机台的第一卷
      v.checkFirstRoll(function(){
        // 判断是否超出了订单匹数设定的第一卷
        v.checkOrderBoltnumOver(function(){
          v.checkHasYarnChange(function(){
            v.yarnchoosecheck();
          });
        });
      });
    },
    yarnchoosecheck(){
      var v = this;
      if(v.isfirstrollflg || v.isovernum){
        v.changeyarn_flg = true;
        v.clothhead_flg = true;
      }else{
        if(v.yarnuseflg && v.hasYarnHisflg){
          v.changeyarn_flg = true;
          v.clothhead_flg = true;
        }else{
          v.changeyarn_flg = false;
          v.clothhead_flg = false;
        }
      }
    },
    checkFirstRoll(callback){ // 判断是否是订单物料机台的第一卷
      var v = this;
      if(v.machineno && v.clothcode && v.fallingtime){
         v.doCheckFirstRollApi(function(res){
          // 判断是否是订单物料机台的第一卷，若是，则勾选是否换纱，且不可编辑
          v.isfirstrollflg = res.isfirstrollflg;
          if(callback)callback();
        })
      }else{
        if(callback)callback();
      }
    },
    doCheckOrderBoltnumApi(callback){
      var v = this;
      // 判断录入的卷是否是超出订单设定匹数的第一卷
      var postMap = {
        "machineno": v.machineno,
        "clothcode": v.clothcode,
        "ddh":v.ddh,
        "wph":v.wph,
        "boltnum":v.boltnum,
        "fallingtime":v.fallingtime
      };
      v.nyy.doPost("/Quality/checkOrderBoltnum", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback(result.data);
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    doCheckWBZErpOrderBoltnumApi(callback){
      var v = this;
      // 判断录入的卷是否是超出订单设定匹数的第一卷
      var postMap = {
        "machineno": v.machineno,
        "clothcode": v.clothcode,
        "ddh":v.ddh,
        "wph":v.wph,
        "boltnum":v.boltnum,
        "fallingtime":v.fallingtime
      };
      v.nyy.doPost("/Quality/checkErpOrderBoltnum", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback(result.data);
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    boltBlur(){
      var v = this;
      if(v.mode!='add') return;
      // 判断是否超出订单设定匹数的第一卷
      v.checkOrderBoltnumOver(function(){
        v.checkHasYarnChange(function(){
          v.yarnchoosecheck();
        });
      });
    },
    checkOrderBoltnumOver(callback){ // 判断是否超出订单设定匹数的第一卷
      var v = this;
      if(v.machineno && v.clothcode && (v.boltnum && parseFloat(v.boltnum) > 0) && v.fallingtime){
        // 若是W编织且是ERP订单，则优先判断是否超出ERP挂换纱返回的最大匹数
        // 若ERP挂换纱返回的最大匹数不超过，则校验 是否超出订单设置匹数的第一卷
        if(v.erpcontract == 1 && v.wbzflag == 1){
          v.doCheckWBZErpOrderBoltnumApi(function(erp_res){
            // 20220408 ERP匹数限制，只能作为参考 弹出提示消息，无需做默认换纱处理
             //v.isovernum = erp_res.erp_over_num;
             v.iserpovernum = erp_res.erp_over_num;
             var erp_max_ps = erp_res.erp_max_ps;
             if(v.iserpovernum){
               if(!v.changeyarn_flg){
                 // 弹出提示消息
                // mui.confirm("一套纱可织最大匹数为" + parseFloat(erp_max_ps).toFixed(2) +"匹，现匹数已超过，是否勾选换纱？", '提示', ['否', '是'], function(e) {
                //   if (e.index == 1) {
                //     v.changeyarn_flg = true;
                //     v.clothhead_flg = true;
                //   }else{
                //     v.doCheckOrderBoltnumApiOtp(callback);
                //   }
                // });
                mui.toast("纱线预估生产" + parseFloat(erp_max_ps).toFixed(2) +"匹，请注意换纱！");
                v.doCheckOrderBoltnumApiOtp(callback);
               }
             }else{
               v.changeyarn_flg = false;
               v.clothhead_flg = false;
               v.doCheckOrderBoltnumApiOtp(callback);
             }
          });
        } else{
           v.doCheckOrderBoltnumApiOtp(callback);
        }
      }else{
        if(callback)callback();
      }
    },
    doCheckOrderBoltnumApiOtp(callback){
      var v = this;
      v.doCheckOrderBoltnumApi(function(res){
          v.isovernum = res.over_num;
          if(v.isovernum){
            v.changeyarn_flg = true;
            v.clothhead_flg = true;
          }else{
            if(!callback){
              v.changeyarn_flg = false;
              v.clothhead_flg = false;
            }
          }
          if(callback)callback();
        });
    },
    checkHasYarnChange(callback){
      var v = this;
      // 当启用挂纱操作时，需要进行挂换纱管理的情况，需要根据挂换纱履历，自动判断是否有换纱 
      // 2021/11/12 追加 启用挂纱且是W编织的ERP订单，才做检查
      if(v.yarnuseflg && v.erpcontract == 1 && v.wbzflag == 1){
        // 机台最近一次落布时间点到当前布卷落布时间点，机台对应的纱架有无挂/换纱操作。
        //2022.02 吴提出 挂纱/换纱时，需要有换纱标记
        if(v.machineno && v.clothcode && v.fallingtime && v.supplementflg != "1"){
          v.doCheckHasYarnHisApi(function(res){
            v.hasYarnHisflg = res.hasYarnHisflg;
            if(callback) callback();
          });
        }else{
          if(callback) callback();
        }
      }else{
        if(callback) callback();
      }
    },
    doCheckHasYarnHisApi(callback){
      var v = this;
      // 机台最近一次落布时间点到当前布卷落布时间点，机台有无换纱操作。
      var postMap = {
        "machineno": v.machineno,
        "clothcode": v.clothcode,
        "ddh":v.ddh,
        "wph":v.wph,
        "boltnum":v.boltnum,
        "fallingtime":v.fallingtime
      };
      v.nyy.doPost("/Quality/checkHasYarnHisWBZ", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback(result.data);
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    // 获取订单剩余数量
    getContractSYAmount(callback) {
      var v = this;
      v.nyy.doPost("/Quality/getContractSYAmount", {
        ddh: v.ddh,
        wph: v.wph
      },
      function(result) {
        if (result.status) {
          // 20250811 剩余未打卡数量 ↓
          v.sysl = result.data.info.sysl;
          // 20250811 剩余未打卡数量 ↑
          if (callback) callback();
        } else {
          mui.toast(result.message);
        }
      }
      );
    },
    handleCreateWzTag(name){
      console.log("add name" + name);
      const v = this;
      // 校验外注卷号
      let tempval = name.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\u3040-\u309F\u30A0-\u30FF-\\\/\#\_\ ]/g,'');

      let newOption = {
        wzrollno: tempval.toUpperCase().trim(),
        machineno: v.machineno,
        clothcode: v.clothcode,
        boltnum: v.boltnum,
        netweight: v.netweight,
        datafrom: "input"
      }
      v.wzrollLst.push(newOption);
      v.wzrollnoinfo = newOption;
      v.wzrollno = newOption.wzrollno;
    },
    // 20251125 获取可选的外注卷号列表 ↓
    getWzrollnoList(flg, callback){
      const v = this;
      let inputWzrollList = v.wzrollLst.filter(item => item.datafrom == 'input');

      if(v.machineno == "" || v.clothcode == "" ){
        if(flg){
          v.wzrollLst = inputWzrollList;
        }
        return;
      }

      // 通过接口获取
      v.nyy.doPost("/Quality/getWzrollnoList", {
        machineno: v.machineno,
        clothcode: v.clothcode
      },
      function(result) {
        if (result.status) {
          let dbWzrollList = result.data.wzrollLst || [];
          if(flg){
            dbWzrollList.push(...inputWzrollList);
          }
          v.wzrollLst = dbWzrollList;
          if (callback) callback();
        } else {
          mui.toast(result.message);
        }
      });

    },
    wzrollnoSel(selectedOption,id){
      const v = this;
      v.wzrollno = selectedOption.wzrollno;
      if(selectedOption.datafrom != 'input'){
        v.boltnum = selectedOption.boltnum;
        v.netweight = selectedOption.netweight;
        v.fallingtime = selectedOption.fallingtime;
        v.dcremark = "横段";
      }
    }
    // 20251125 获取可选的外注卷号列表 ↑
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
@import "../../static/css/filterorder.css";
@import "../../static/css/quality.css";
</style>



// WEBPACK FOOTER //
// src/components/qualityDetailBZ.vue